import React, { useEffect } from 'react';
import { Routes, Route, BrowserRouter, Navigate } from "react-router-dom";
import { AnimatePresence } from 'framer-motion';
import { login_path, privacy_info, default_path } from './utils/navigation/path';
import Fallback from './common/componenets/fallback';
import RequireAuth from './utils/wrappers/require_auth';
import { Hub, Auth } from 'aws-amplify';
import { useDispatch } from 'react-redux';
import { on_user_login, on_user_logout } from './db/redux/features/auth/auth.slice';
import { clear_state } from './db/redux/features/app/app.slice';
import PrivacyInfo from './screens/privacy_info';
import { clear_response_state } from './db/redux/features/gpt_response/response.slice';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { clear_prompt_state } from './db/redux/features/prompt_meta/prompt_meta.slice';

const Login = React.lazy(() => import('./screens/login'));
const Home = React.lazy(() => import('./screens/home'));

function App() {
  const dispatch = useDispatch();

  useEffect(() => {
    const hydrateUser = async (source = 'unknown') => {
      try {
        console.log('[AUTH] hydrateUser start from', source);
        const user = await Auth.currentAuthenticatedUser();
        console.log('[AUTH] currentAuthenticatedUser success', user?.username, user?.attributes);
        const attrs = user?.attributes || {};
        const accepted_terms =
          typeof attrs['custom:accepted'] !== 'undefined'
            ? String(attrs['custom:accepted']).toLowerCase() === 'true'
            : false;

        console.log('[AUTH] dispatching on_user_login', {
          uid: user?.username || '',
          accepted_terms,
          attrs
        });

        dispatch(
          on_user_login({
            uid: user?.username || '',
            has_accepted_terms: accepted_terms,
          })
        );
      } catch (e) {
        console.log('[AUTH] hydrateUser failed from', source, e);
      }
    };

    hydrateUser('mount');

    const unsubscribe = Hub.listen('auth', (data) => {
      const { payload } = data;
      console.log('[AUTH] Hub event', payload?.event, payload);

      if (payload.event === 'signIn') {
        hydrateUser('hub:signIn');
      }

      if (payload.event === 'signOut') {
        dispatch(on_user_logout());
        setTimeout(() => {
          dispatch(clear_state());
          dispatch(clear_prompt_state());
          dispatch(clear_response_state());
        }, 200);
      }
    });

    return () => unsubscribe();
  }, [dispatch]);

  return (
    <BrowserRouter>
      <div className='flex justify-center items-center w-full h-full bg-white'>
        <div className='w-full md:w-[400px] lg:w-[410px] h-full md:h-[100vh] lg:h-[95%] xl:h-[90%] bg-bg'>
          <AnimatePresence mode="wait">
            <Routes>
              <Route path="/auth" element={<Navigate to={login_path} replace />} />

              <Route
                path={login_path}
                element={
                  <RequireAuth>
                    <React.Suspense fallback={<Fallback />}>
                      <Login />
                    </React.Suspense>
                  </RequireAuth>
                }
              />

              <Route
                path={privacy_info}
                element={
                  <RequireAuth>
                    <React.Suspense fallback={<Fallback />}>
                      <PrivacyInfo />
                    </React.Suspense>
                  </RequireAuth>
                }
              />

              <Route
                path="/app/*"
                element={
                  <RequireAuth>
                    <React.Suspense fallback={<Fallback />}>
                      <Home />
                    </React.Suspense>
                  </RequireAuth>
                }
              />

              <Route
                path="/express/*"
                element={
                  <RequireAuth>
                    <React.Suspense fallback={<Fallback />}>
                      <Home />
                    </React.Suspense>
                  </RequireAuth>
                }
              />

              <Route path="*" element={<Navigate to={default_path} replace />} />
            </Routes>
          </AnimatePresence>

          <ToastContainer />
        </div>
      </div>
    </BrowserRouter>
  );
}

export default App;
